import axios from 'axios';

const BACKEND_URL = 'https://ksv-latest.onrender.com';
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = sessionStorage.getItem('ksv_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const authApi = {
  login: (username, password) => api.post('/auth/login', { username, password }).then(r => r.data),
};

export const publicApi = {
  getMenu: (kind) => api.get(`/${kind}`).then(r => r.data),
  getAlbum: (album) => api.get(`/albums/${album}`).then(r => r.data),
};

export const adminApi = {
  uploadMenu: (kind, file) => {
    const fd = new FormData();
    fd.append('file', file);
    return api.post(`/admin/${kind}`, fd, { headers: { 'Content-Type': 'multipart/form-data' } }).then(r => r.data);
  },
  deleteMenu: (kind) => api.delete(`/admin/${kind}`).then(r => r.data),
  uploadAlbum: (album, files) => {
    const fd = new FormData();
    files.forEach((f) => fd.append('files', f));
    return api.post(`/admin/albums/${album}`, fd, { headers: { 'Content-Type': 'multipart/form-data' } }).then(r => r.data);
  },
  deleteAlbumImage: (album, id) => api.delete(`/admin/albums/${album}/${id}`).then(r => r.data),
  moveAlbumImage: (album, id, direction) => api.put(`/admin/albums/${album}/${id}/move`, { direction }).then(r => r.data),
};

export function imageUrl(path) {
  if (!path) return '';
  if (path.startsWith('http')) return path;
  return `${BACKEND_URL}${path}`;
}
